<script setup>
import { computed } from 'vue';

  const props = defineProps({
    isSideBySide: {
      default: false,
      type: Boolean,
    },
    rating: {
      default: () => 0,
      type: Number,
    },
    ratings: {
      default: () => null,
      type: Object,
    },
  }), 
  totalRatingRatio = computed(() => 100 / props.ratings?.total?.count),
  calculateRatingPercentage = (count) => Math.round((count ?? 0) * totalRatingRatio.value);
</script>

<template>
  <div
    v-if="props.ratings"
    :class="[props.isSideBySide ? 'mt-3' : '']"
  >
    <div
      :class="[props.isSideBySide ? 'shadow-md p-4 mb-2 rounded-xl' : ' shadow-none', 'border-0']"
    >
      <div class="px-0">
        <div
          :class="['grid', props.isSideBySide ? 'flex-nowrap space-x-3 grid-cols-5' : 'flex-wrap grid-cols-1']"
        >
          <div
            :class="[props.isSideBySide ? 'col-span-1' : 'col-span-1', 'px-0 mr-2 self-center']"
          >
            <span
              :class="[props.isSideBySide ? 'text-5xl' : 'text-4xl', 'h1 font-bold text-gray-600']"
            >
              {{ props.rating }}
            </span>
            <span class="block font-bold text-sm text-gray-500">out of 5</span>
          </div>

          <div
            v-if="props.ratings.items.length > 0"
            class="col-span-4"
          >
            <div
              v-for="(item) in props.ratings.items"
              :key="item.value"
              class="flex items-center"
            >
              <span 
                class="text-xs font-medium mr-2 text-gray-500"
              >{{ item.value }}</span>
              <div
                class="w-full bg-amber-200 rounded-full h-1 dark:bg-amber-200"
              >
                <div
                  aria-describedby="rating percentage"
                  role="progressbar"
                  :aria-valuenow="calculateRatingPercentage(item.count)"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  :class="[item.count > 0 ? 'bg-amber-500' : 'bg-amber-200', 'h-1 rounded-full']"
                  :style="{ width: calculateRatingPercentage(item.count) + '%' }"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="text-right w-full mt-0.5">
          <span
            class="text-gray-500 text-sm font-medium text-right"
          >{{ props.ratings?.total?.count }}
            ratings</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
